module.exports = __webpack_public_path__ + "img/img_案例10.49296a27.png";